var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-truncate" },
    [
      _vm.item.type === "button"
        ? [
            typeof _vm.item.label !== "undefined" && _vm.item.label !== ""
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    class: _vm.item.textColor + "--text",
                                    attrs: {
                                      disabled: _vm.isDisabled,
                                      color: _vm.item.color
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.doItemAction($event)
                                      }
                                    }
                                  },
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.item.text) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      114389243
                    )
                  },
                  [
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.item.label) +
                          "\n            "
                      )
                    ])
                  ]
                )
              : _c(
                  "v-btn",
                  {
                    class: _vm.item.textColor + "--text",
                    attrs: { disabled: _vm.isDisabled, color: _vm.item.color },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.doItemAction($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.item.text) + "\n        "
                    )
                  ]
                )
          ]
        : _vm.item.type === "icon"
        ? [
            typeof _vm.item.label !== "undefined" && _vm.item.label !== ""
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    attrs: {
                                      icon: "",
                                      disabled: _vm.isDisabled
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.doItemAction($event)
                                      }
                                    }
                                  },
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: _vm.item.color } },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.item.icon) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3801628389
                    )
                  },
                  [
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n            " + _vm._s(_vm.item.label) + "\n        "
                      )
                    ])
                  ]
                )
              : _c(
                  "v-btn",
                  {
                    attrs: { icon: "", disabled: _vm.isDisabled },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.doItemAction($event)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { color: _vm.item.color } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.item.icon) +
                          "\n            "
                      )
                    ])
                  ],
                  1
                )
          ]
        : _vm.item.type === "text"
        ? [
            _c(
              "span",
              { staticClass: "body-1", class: _vm.item.color + "--text" },
              [_vm._v("\n        " + _vm._s(_vm.item.text) + "\n    ")]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }